import React from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Barchart = (props) => {
  const labels = [];
  const dataset = [];
  const colors = ['#03A9F6', '#025F9E', '#59C98A',];

  for (let i = 0; i < 3; i++) {
    labels.push(props.PChart[i].difficultyLevel);
    dataset.push(props.PChart[i].answeredPercent)
  }
  const data = {
    labels: labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: colors.slice(0, dataset.length),
        barThickness: 80,
      }
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: false, 
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (context.parsed.y !== null) { label += context.parsed.y + "%"; }
            return label;
          }
        }
      },
      datalabels: {
        // anchor: "end",
        // align: "end",
           formatter: (value) => value + "%",
 color: () => "#FFFFFF",
        font: {
          weight: "bold",
          size: 12,
        },

       
      },

    },
    scales: {
      x: { stacked: false, title: { display: true, text: 'Difficulty Level' }, grid: { display: false, }, },
      y: { max: 100, stacked: false, title: { display: true, text: 'Average % Achievement' }, beginAtZero: true, }
    }
  };
  return (
    <Bar options={options} data={data} />
  )
};
export default Barchart;